module.exports = __webpack_public_path__ + "img/wav.94964108.png";